import { useEffect } from "react"
import { setData, setUser } from "../../features/user/userSlice"
import { useAppDispatch } from "../hooks"
import { getParamFromUrl } from "../../utilities/urlResolver";

const useInitializeUser = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const localUser = localStorage.getItem('hf_user');
    if (localUser) {
      const parsedUser = JSON.parse(localUser);
      dispatch(setUser(parsedUser));
    }

    const getEntryFlowParams = () => {
      const data = {
        destinations: getParamFromUrl('pr_destinations'),
        destinationGroups: getParamFromUrl('pr_destinationsGroups'),
        similarDestinations: getParamFromUrl('pr_similar_dest'),
        themes: getParamFromUrl('pr_what'),
        airports: getParamFromUrl('pr_fromwhere'),
        entryFlow: getParamFromUrl('pr_entryFlow'),
        entryFlowMessage: getParamFromUrl('pr_messageId'),
        name: getParamFromUrl('pr_name'),
        capacity: getParamFromUrl('pr_capacity'),
        hostingLevelPref: getParamFromUrl('pr_hostingLevelPref'),
        hotelId: getParamFromUrl('pr_hotelId'),
        startDate: getParamFromUrl('pr_startDate'),
        endDate: getParamFromUrl('pr_endDate'),
        welcome: getParamFromUrl('pr_welcome'),
      }

      return data
    };

    dispatch(setData({ key: 'entryFlowParams', value: getEntryFlowParams() }));

    document.addEventListener('travelyo:user', (event) => {
      if (event.detail.name === 'userContextSet' || event.detail.name === 'getUserContext' || event.detail.name === 'loginModal.success') {
        const user = localStorage.getItem('hf_user');
        if (user) {
          dispatch(setUser(JSON.parse(user)));
        }
      }
    });
  }, [dispatch])
}

export default useInitializeUser
